import styles from './EmailConfirmedView.module.css'
import { Button } from '@/components/Button'
import { EmailConfirmationScreen } from '@/features/email-confirmation/components/EmailConfirmationScreen'

export interface EmailConfirmedViewProps {
  onSignIn: () => unknown
  logoPrimary: string
  landingPageImage: string
}

export function EmailConfirmedView({
  onSignIn,
  logoPrimary,
  landingPageImage,
}: EmailConfirmedViewProps) {
  return (
    <EmailConfirmationScreen
      logoPrimary={logoPrimary}
      landingPageImage={landingPageImage}
    >
      <div className={styles.title}>You're all set!</div>
      <div className={styles.description}>
        Great news! You have confirmed your email and can now sign in to the
        platform.
      </div>
      <div className={styles.signInButton}>
        <Button
          label="Sign In"
          size="cta"
          block
          variant="primary"
          onPress={onSignIn}
        />
      </div>
    </EmailConfirmationScreen>
  )
}
